module.exports = __webpack_public_path__ + "static/img/beian_icon.d0289dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/beian_icon.png
// module id = F60W
// module chunks = 1